import { LeadPreviewContent } from "features/leads/components";

import { Tag } from "common/components/ui/Tag";
import type { DetailedLead } from "common/types";

import Certifications from "../Certifications";
import CurrentExperience from "../CurrentExperience";
import Education from "../Education";
import Experience from "../Experience";
import Languages from "../Languages";
import Skills from "../Skills";
import Volunteering from "../Volunteering";
import SectionContainer from "./SectionContainer";

export default function DesktopLeadDetails({
  lead,
  profileId,
  isLoading,
}: {
  lead: DetailedLead;
  profileId: string;
  isLoading: boolean;
}) {
  return (
    <div className="grid gap-4 grid-cols-[352px_auto]">
      <div className="flex h-fit flex-col rounded-5xl border border-black-200">
        <LeadPreviewContent initialState={profileId} mode="leadDetails" />
      </div>
      <div className="flex flex-col">
        <div className="mb-8 flex flex-col last:mb-0">
          <h2 className="mb-3 rounded-2xl bg-purple-50 px-4 py-2 text-button-md text-purple-600">
            Current position{lead?.current_experience.length > 1 && "s"}
          </h2>
          <CurrentExperience
            currentExperience={lead?.current_experience}
            isLoading={isLoading}
          />
        </div>
        <SectionContainer title="Experience">
          <Experience
            workExperience={lead?.work_experience}
            isLoading={isLoading}
          />
        </SectionContainer>

        <SectionContainer title="Education">
          <Education education={lead?.education} isLoading={isLoading} />
        </SectionContainer>
        {lead && (
          <>
            {!!lead.volunteer_experience.length && (
              <SectionContainer title="Volunteering">
                <Volunteering volunteering={lead.volunteer_experience} />
              </SectionContainer>
            )}
            {!!lead.certifications.length && (
              <SectionContainer title="License & certs">
                <Certifications certification={lead.certifications} />
              </SectionContainer>
            )}
            {!!lead.skills.length && (
              <SectionContainer
                title="Skills"
                extraComponent={
                  <Tag variant="primary-black">{lead.skills.length}</Tag>
                }
              >
                <Skills skills={lead.skills} />
              </SectionContainer>
            )}
            {!!lead.languages.length && (
              <SectionContainer title="Languages">
                <Languages languages={lead.languages} />
              </SectionContainer>
            )}
          </>
        )}
      </div>
    </div>
  );
}
